export default Object.freeze ({
	CAMERA: `camera`,
	EDITING: `editing`,
	THUMBNAILS: `thumbnails`,
});
